import EventsWebservice from './EventsWebservice';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class AirportService extends EventsWebservice{
	constructor() {
		super('/airports');
	}
	findAirports(query) {
		return axios.get(this.url, {params: {query}});
	}
}



// WEBPACK FOOTER //
// ./src/services/AirportService.js